import { Component, HostBinding, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { map, take, tap } from 'rxjs/operators'
import { AuthManager } from 'src/app/shared/auth/AuthManager'
import { GrowthToolkitClient } from 'src/app/shared/services/ppv.api'

@Component({
   selector: 'hospital-manager-dashboard',
   templateUrl: './hospital-manager-dashboard-page.component.html',
   styleUrls: ['./hospital-manager-dashboard-page.component.scss'],
   standalone: false,
})
export class GrowthToolkitHospitalManagerDashboardPage implements OnInit {
   practiceSKeyNumber = 0
   practiceName = ''

   //prettier-ignore
   constructor(
      private authManager: AuthManager,
      private route: ActivatedRoute,
      public router: Router,
      private growthToolkitClient: GrowthToolkitClient
    ) {}

   ngOnInit(): void {
      const param = this.route.paramMap.subscribe((params) => {
         this.practiceSKeyNumber = Number(params.get('practiceSKey'))
      })

      this.authManager
         .getCurrentUser()
         .pipe(
            take(1),
            map((user) => {
               const match = user.practices.find((p) => p?.id === this.practiceSKeyNumber)
               return match?.nameId ?? ''
            })
         )
         .subscribe((nameId: string | null) => {
            this.practiceName = nameId
         })
   }

   @HostBinding('class.full-flex-height') fullFlexHeight = true
}
